import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraIncident } from '../../models/doraIncident.ts';

interface DoraIncidentState {
  doraIncidents: DoraIncident[];
  selectedDoraIncident: DoraIncident | null;
}

const initialState: DoraIncidentState = {
  doraIncidents: [],
  selectedDoraIncident: null,
};

const doraIncidentSlice = createSlice({
  name: 'doraIncident',
  initialState,
  reducers: {
    setDoraIncidents(state, action: PayloadAction<DoraIncident[]>) {
      state.doraIncidents = action.payload;
    },
    addDoraIncident(state, action: PayloadAction<DoraIncident>) {
      state.doraIncidents.push(action.payload);
    },
    updateDoraIncident(state, action: PayloadAction<DoraIncident>) {
      const index = state.doraIncidents.findIndex(incident => incident.id === action.payload.id);
      if (index !== -1) state.doraIncidents[index] = action.payload;
    },
    removeDoraIncident(state, action: PayloadAction<number>) {
      state.doraIncidents = state.doraIncidents.filter(incident => incident.id !== action.payload);
    },
    setSelectedDoraIncident(state, action: PayloadAction<DoraIncident | null>) {
      state.selectedDoraIncident = action.payload;
    },
  },
});

export const {
  setDoraIncidents,
  addDoraIncident,
  updateDoraIncident,
  removeDoraIncident,
  setSelectedDoraIncident,
} = doraIncidentSlice.actions;

export const selectDoraIncidents = (state: RootState) => state.doraIncident.doraIncidents;
export const selectSelectedDoraIncident = (state: RootState) => state.doraIncident.selectedDoraIncident;

export default doraIncidentSlice.reducer;
